import React, { useState } from 'react';
import { format } from 'date-fns';
import { es, enUS, de as deLocale } from 'date-fns/locale';
import { CalendarIcon, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Calendar } from '../ui/calendar';
import { useAuth } from '../../contexts/AuthContext';
import { useTranslation } from '../../hooks/useTranslation';

// Mismo patrón Popover+Calendar que Planner.js (mode="single", locale,
// weekStartsOn) — no se inventa un date-picker nuevo para este módulo.
export function MarkFollowUpDialog({ open, onOpenChange, onConfirm, submitting }) {
  const { language } = useAuth();
  const { t } = useTranslation();
  const locale = language === 'es' ? es : language === 'de' ? deLocale : enUS;

  const [date, setDate] = useState(new Date());
  const [note, setNote] = useState('');
  const [calendarOpen, setCalendarOpen] = useState(false);

  const handleConfirm = () => {
    const iso = new Date(date);
    iso.setHours(9, 0, 0, 0);
    onConfirm(iso.toISOString(), note.trim() || null);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('aiLeadScanner.leadDetail.markFollowUp')}</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div>
            <Label>{t('aiLeadScanner.leadDetail.followUpDate')}</Label>
            <Popover open={calendarOpen} onOpenChange={setCalendarOpen}>
              <PopoverTrigger asChild>
                <Button variant="outline" className="w-full justify-start mt-1">
                  <CalendarIcon className="w-4 h-4 mr-2" />
                  {format(date, 'EEEE, d MMMM yyyy', { locale })}
                </Button>
              </PopoverTrigger>
              <PopoverContent className="w-auto p-0" align="start">
                <Calendar
                  mode="single"
                  selected={date}
                  onSelect={(d) => { if (d) { setDate(d); setCalendarOpen(false); } }}
                  locale={locale}
                  weekStartsOn={language === 'en' ? 0 : 1}
                  initialFocus
                />
              </PopoverContent>
            </Popover>
          </div>

          <div>
            <Label>{t('aiLeadScanner.leadDetail.followUpNote')}</Label>
            <Textarea
              value={note}
              onChange={(e) => setNote(e.target.value)}
              rows={3}
              className="mt-1"
            />
          </div>

          <div className="flex justify-end gap-2">
            <Button variant="ghost" onClick={() => onOpenChange(false)} disabled={submitting}>
              {t('aiLeadScanner.leadDetail.cancel')}
            </Button>
            <Button onClick={handleConfirm} disabled={submitting}>
              {submitting && <Loader2 className="w-4 h-4 mr-1.5 animate-spin" />}
              {t('aiLeadScanner.leadDetail.save')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
